const numberFormatter = new Intl.NumberFormat('en-US', {
	style: 'decimal',
	maximumFractionDigits: 0
});
export default function (value, arg) {
	switch (arg) {
		case 'number':
			return numberFormatter.format(value);
		case 'currency':
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD'
			}).format(value);
		case 'currency-no-decimals':
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD',
				maximumFractionDigits: 0
			}).format(value);
		case 'decimal':
			return new Intl.NumberFormat('en-US', {
				style: 'decimal',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(value);
		case 'percent':
			return new Intl.NumberFormat('en-US', {
				style: 'percent'
			}).format(value);
		case 'percent-2-decimals':
			return new Intl.NumberFormat('en-US', {
				style: 'percent',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(value);
		case 'percent-1-decimal':
			return new Intl.NumberFormat('en-US', {
				style: 'percent',
				minimumFractionDigits: 1,
				maximumFractionDigits: 1
			}).format(value);
	}
	return value;
}
